/**
 * Created by henian.xu on 2019/4/27.
 *
 */

const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('assets/svgs', false, /\.svg$/);
requireAll(req);
